import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const ALL_NAV = [
  { id: 'dashboard',    icon: '⬡', label: 'Dashboard',      path: '/',            roles: ['admin','scheduler','viewer'] },
  { id: 'series',       icon: '◈', label: 'Series',          path: '/series',      roles: ['admin','scheduler','viewer'] },
  { id: 'divisions',    icon: '◫', label: 'Divisions',       path: '/divisions',   roles: ['admin','scheduler','viewer'] },
  { id: 'teams',        icon: '◉', label: 'Teams',           path: '/teams',       roles: ['admin','scheduler','viewer','team_user'] },
  { id: 'grounds',      icon: '⬕', label: 'Grounds',         path: '/grounds',     roles: ['admin','scheduler','viewer'] },
  { id: 'availability', icon: '◷', label: 'Availability',    path: '/availability',roles: ['admin','scheduler'] },
  { id: 'conditions',   icon: '⧉', label: 'Conditions',      path: '/conditions',  roles: ['admin','scheduler'] },
  { id: 'schedule',     icon: '▦', label: 'Schedule',        path: '/schedule',    roles: ['admin','scheduler','viewer','team_user'] },
  { id: 'cricclubs',    icon: '⟳', label: 'CricClubs Sync',  path: '/cricclubs',   roles: ['admin'] },
  { id: 'users',        icon: '◎', label: 'Users & Roles',   path: '/users',       roles: ['admin'] },
];

export default function Layout({ children }) {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const navItems = ALL_NAV.filter(n => user && n.roles.includes(user.role));

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>
      {/* Sidebar */}
      <div style={{
        width: collapsed ? 56 : 210,
        background: 'var(--surface)',
        borderRight: '1px solid var(--border)',
        display: 'flex', flexDirection: 'column', flexShrink: 0,
        position: 'sticky', top: 0, height: '100vh', overflowY: 'auto',
        transition: 'width .2s'
      }}>
        {/* Logo */}
        <div style={{ padding: collapsed ? '20px 8px 14px' : '20px 16px 14px', overflow: 'hidden' }}>
          {!collapsed && (
            <>
              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--accent)', letterSpacing: '2px', textTransform: 'uppercase' }}>Mich-CA</div>
              <div style={{ fontSize: 16, fontWeight: 800, lineHeight: 1.1, marginTop: 2 }}>Schedule<br />Portal</div>
              <div style={{ fontSize: 10, color: 'var(--mid)', marginTop: 4 }}>2026 Season</div>
            </>
          )}
          {collapsed && <span style={{ fontSize: 18, color: 'var(--accent)' }}>◈</span>}
        </div>

        {/* Collapse toggle */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="btn btn-ghost btn-sm"
          style={{ margin: '0 8px 8px', padding: '4px', fontSize: 11 }}
        >
          {collapsed ? '→' : '← Collapse'}
        </button>

        <div style={{ width: '90%', height: '1px', background: 'var(--border)', margin: '0 auto 8px' }} />

        {/* Nav items */}
        {navItems.map(n => (
          <NavLink key={n.id} to={n.path}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10,
              padding: collapsed ? '10px 16px' : '10px 16px',
              justifyContent: collapsed ? 'center' : 'flex-start',
              background: isActive ? 'rgba(0,200,150,.1)' : 'transparent',
              borderLeft: `3px solid ${isActive ? 'var(--accent)' : 'transparent'}`,
              color: isActive ? 'var(--accent)' : 'var(--mid)',
              textDecoration: 'none', fontSize: 13,
              fontFamily: "'Syne', sans-serif",
              fontWeight: isActive ? 700 : 400,
              transition: 'all .15s',
            })}
            title={collapsed ? n.label : undefined}
          >
            <span style={{ fontSize: 16, flexShrink: 0 }}>{n.icon}</span>
            {!collapsed && n.label}
          </NavLink>
        ))}

        {/* User info + logout */}
        <div style={{ marginTop: 'auto', padding: '14px 16px', borderTop: '1px solid var(--border)' }}>
          {!collapsed && (
            <>
              <div style={{ fontSize: 11, color: 'var(--mid)' }}>Logged in as</div>
              <div style={{ fontSize: 13, fontWeight: 700, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user?.full_name}
              </div>
              <div style={{ fontSize: 11, color: 'var(--accent)', marginTop: 1, textTransform: 'capitalize' }}>{user?.role?.replace('_', ' ')}</div>
            </>
          )}
          <button
            onClick={handleLogout}
            className="btn btn-ghost btn-sm"
            style={{ width: '100%', marginTop: 8, justifyContent: 'center' }}
            title="Logout"
          >
            {collapsed ? '↩' : '↩ Logout'}
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ flex: 1, padding: 24, overflowY: 'auto', maxWidth: `calc(100vw - ${collapsed ? 56 : 210}px)` }}>
        {children}
      </div>
    </div>
  );
}
